<template>
	<div class="survey">
		<div class="survey-container mt-10">
			<div class="mb-5" style="text-align: right; margin-top:-20px;">
        <img
          width="119"
          :src="$apiUrl + '/storage/jsQmcWAjDX5AsCIb6C9ZyoJJcvrCVHI7Kc4orTNl.jpeg'"
          alt=""
        />
			</div>

			<div v-show="stepIndex === 0">
				<h2>Hur har du rest den senaste månaden?</h2>
				<p><em class="smaller-em">Fundera på vad som känns rimligt och fyll i det du tror.</em></p>

				<h4 class="mt-2 mb-1">Hur många enkelresor har du gjort per vecka, i genomsnitt?</h4>
        		<em class="smaller-em">(Enkelresor = t.ex. att resa jobbet tur-och-retur räknas som två enkelresor. Räkna med helger, men inte långresor på semester och dylikt)</em>

				<div class="survey-thirds mt-3">
					<div class="survey-thirds-first" :class="{surveyError: errors.includes('numberOfTrips')}">Antal resor:</div>

					<div class="survey-thirds-middle">
						<vue-slider :max="35" v-model="numberOfTrips"></vue-slider>
					</div>

					<div class="survey-thirds-last"><v-text-field hide-details v-model="numberOfTrips"></v-text-field> resor/vecka</div>
				</div>

				<h4 class="mt-2 mb-1" :class="{surveyError: errors.some(e => ['frequencyWalk', 'frequencyMisc', 'frequencyCar', 'frequencyTransit', 'frequencyBike'].includes(e))}">Hur ofta använder du respektive färdmedel?</h4>
				<v-select v-model="frequencyWalk" :items="modeOfTransportFrequency" prepend-icon="🚶"  label="Promenad" solo></v-select>
				<v-select v-model="frequencyBike" :items="modeOfTransportFrequency" prepend-icon="🚲"  label="Cykel" solo></v-select>
				<v-select v-model="frequencyTransit" :items="modeOfTransportFrequency" prepend-icon="🚌"  label="Kollektivtrafik" solo></v-select>
				<v-select v-model="frequencyCar" :items="modeOfTransportFrequency" prepend-icon="🚗"  label="Bil" solo></v-select>
				<v-select v-model="frequencyMisc" :items="modeOfTransportFrequency" prepend-icon="-"  label="Övrigt" solo></v-select>

				<h4 class="mt-2 mb-1">Hur långa är dina enkelresor, i genomsnitt?</h4>
				<em class="smaller-em">(Gör din bästa uppskattning)</em>

				<div class="survey-thirds mt-3">
					<div class="survey-thirds-first" :class="{surveyError: errors.includes('averageTripDistance')}">Reslängd:</div>

					<div class="survey-thirds-middle">
						<vue-slider :max="100" :step="0.5" v-model="averageTripDistance"></vue-slider>
					</div>

					<div class="survey-thirds-last"><v-text-field hide-details v-model="averageTripDistance"></v-text-field> km</div>
				</div>

				<div class="survey-sum mt-3">I genomsnitt reser du <strong>{{ weeklyDistance }} km per vecka</strong>, vilket blir <strong>{{ yearlyDistance }} km</strong> utslaget på ett år (ifall du reser likadant alla veckor om året).
					<br/>
					<em>Om reslängden per vecka verkar rimlig, vänligen gå vidare i enkäten. Om inte, justera i frågorna ovan.</em></div>


				<div class="nudgd-btn inline survey-submit mt-5" @click="confirmFirstStep()" v-if=" ! firstStepConfirmed">Bekräfta hur långt du rest</div>
				<div style="clear:both;"></div>


				<div v-show="firstStepConfirmed">
					<h4 class="mt-10" :class="{surveyError: errors.includes('weeklyDistanceRatio')}">Fördela din veckovisa reslängd utefter färdmedel:</h4>
					<em class="smaller-em">Utifrån dina svar på förra sidan reser du i genomsnitt <strong>{{ weeklyDistance }} km per vecka</strong>.</em>

					<vue-slider
						class="my-5 hide-first-and-last"
						v-model="weeklyDistanceRatio"
						:enable-cross="false"
						tooltip="false"
						:clickable="false"
						:process="weeklyDistanceRatioProcess"
					>
						<template v-slot:dot="{index}">
							<div class="custom-dot" style="display:none;" v-if="index === 0"></div>
							<div class="custom-dot" v-if="index === 1">🚶</div>
							<div class="custom-dot" v-if="index === 2">🚲</div>
							<div class="custom-dot" v-if="index === 3">🚌</div>
							<div class="custom-dot" v-if="index === 4">🚗</div>
							<div class="custom-dot" style="display:none;" v-if="index === 5"></div>
						</template>
					</vue-slider>

					<div class="nudgd-btn small" @click="resetWeeklyDistanceRatio()" style="float:right; font-size: 13px; background-color: #999;">Återställ</div>

					<ul class="mt-3 unstyled survey-list">
						<li><strong>🚶 Promenad</strong> {{ Math.round((weeklyDistanceRatio[1] - weeklyDistanceRatio[0]) / 100 * weeklyDistance) }} km</li>
						<li><strong>🚲 Cykel</strong> {{ Math.round((weeklyDistanceRatio[2] - weeklyDistanceRatio[1]) / 100 * weeklyDistance) }} km</li>
						<li><strong>🚌 Kollektivtrafik</strong> {{ Math.round((weeklyDistanceRatio[3] - weeklyDistanceRatio[2]) / 100 * weeklyDistance) }} km</li>
						<li><strong>🚗 Bil</strong> {{ weeklyCarDistance }} km</li>

						<li><strong>
							<v-tooltip bottom>
						      <template v-slot:activator="{ on, attrs }">
						        <span
						          v-bind="attrs"
						          v-on="on"
						        >
						        <span style="display: inline-block; width:15px; height:3px; position: relative; top: -3px; margin-right: 5px; background-color: #CE349D;"></span> Övrigt <div class="tooltip-container"><span class="icon-info"></span></div>
						        </span>
						      </template>
						      <span>t.ex. elsparkcykel, skateboard etc."</span>
						    </v-tooltip>
						   </strong>{{ Math.round((weeklyDistanceRatio[5] - weeklyDistanceRatio[4]) / 100 * weeklyDistance) }} km</li>


						<li class="survey-list-sum"><strong>SUMMA</strong> {{ weeklyDistance }} km</li>
					</ul>


					<div v-if="weeklyCarDistance">
						<h4 class="mt-10" :class="{surveyError: errors.includes('fuelRatio')}">Hur är dina bilresor fördelade utifrån drivmedel?</h4>

						<vue-slider
							class="mt-3"
							dotSize="22"
							v-model="fuelRatio"
							:clickable="false"
							:enable-cross="false"
							tooltip="false"
							:process="fuelRatioProcess"
						>
							<template v-slot:dot="{index}">
								<div class="custom-dot" style="display:none;" v-if="index === 0"></div>
								<div class="custom-dot" style="display:none;" v-if="index === 3"></div>
							</template>
						</vue-slider>

						<ul class="mt-3 unstyled survey-list">
							<li><span style="display: inline-block; width:20px; height:3px; position: relative; top: -3px; margin-right: 7px; background-color: #35A038;"></span>
								<strong>El</strong> {{ Math.round((fuelRatio[1] - fuelRatio[0]) / 100 * weeklyCarDistance) }} km</li>
							<li><span style="display: inline-block; width:20px; height:3px; position: relative; top: -3px; margin-right: 7px; background-color: #29ABCA;"></span>
							 <strong>Hybrid/gas</strong> {{ Math.round((fuelRatio[2] - fuelRatio[1]) / 100 * weeklyCarDistance) }} km</li>
							<li><span style="display: inline-block; width:20px; height:3px; position: relative; top: -3px; margin-right: 7px; background-color: #000000;"></span>
								<strong>Bensin/diesel/etanol</strong> {{ Math.round((fuelRatio[3] - fuelRatio[2]) / 100 * weeklyCarDistance) }} km</li>
						</ul>

						<h4 class="mb-3 mt-10">Kommentar <span style="font-weight:normal;">(ej obligatorisk)</span></h4>
						<v-textarea rows="4" hide-details solo v-model="commentary"></v-textarea>
						<div class="survey-help mt-2">(Vänligen lämna inga personuppgifter i detta fält)</div>
					</div>
				</div>

				<div v-if="firstStepConfirmed" class="nudgd-btn inline survey-submit mt-10" @click="nextStep()">Gå vidare</div>
				<div style="clear:both;"></div>
			</div>

			<div v-show="stepIndex === 1">
				<h4 class="mt-2 mb-4" :class="{surveyError: errors.includes('answeredPreSurvey')}">I början på året skickade vi ut ett SMS med en liknande enkät. Besvarade du denna?</h4>

				<div class="survey-radio-row mb-6">
					<v-radio-group class="mt-0" v-model="answeredPreSurvey" row>
						<v-radio label="Ja" value="Ja"></v-radio>
						<v-radio label="Nej" value="Nej"></v-radio>
					</v-radio-group>
				</div>

				<h4 class="mt-2 mb-4" :class="{surveyError: errors.includes('usedResvana')}">
					Ditt hushåll har de senaste månaderna fått samhällsinformation i brevlådan om hållbart resande, t.ex. cykel och kollektivtrafik. Utskicken var från Jönköpings kommun. De innehöll bland annat en QR-kod och länk till en tjänst kallad Resvana. Vilket av följande alternativ stämmer bäst för dig/ditt hushåll?
				</h4>

				<div class="survey-radio-row mb-6">
					<v-radio-group class="mt-0" v-model="usedResvana">
						<v-radio label="Jag har inte sett något av utskicken" value="Jag har inte sett något av utskicken"></v-radio>
						<v-radio label="Jag har sett minst ett utskick, men inte läst något av informationen" value="Jag har sett minst ett utskick, men inte läst något av informationen"></v-radio>
						<v-radio label="Jag har läst minst ett utskick" value="Jag har läst minst ett utskick"></v-radio>
						<v-radio label="Jag har besökt tjänsten Resvana" value="Jag har besökt tjänsten Resvana"></v-radio>
						<v-radio label="Jag har läst minst ett utskick och besökt tjänsten Resvana" value="Jag har läst minst ett utskick och besökt tjänsten Resvana"></v-radio>
					</v-radio-group>
				</div>

				<div v-if="usedResvana === 'Jag har besökt tjänsten Resvana' || usedResvana === 'Jag har läst minst ett utskick och besökt tjänsten Resvana'">
					<h2>Tjänsten Resvana</h2>
					<h4 class="mt-4" :class="{surveyError: errors.includes('resvanaEffect')}">I vilken utsträckning skulle du säga att Resvana har bidragit till ditt val av färdmedel?</h4>
					<em class="smaller-em">(0 = Inte alls; 10 = Helt och hållet)</em>
					<vue-slider marks class="mt-3" :max="10" v-model="resvanaEffect"></vue-slider>


					<h4 class="mt-10 mb-4">Tjänsten har fått mig att börja...</h4>

					<div class="survey-radio-row">
						<div class="survey-radio-row-first" :class="{surveyError: errors.includes('moreWalking')}">...promenerera (eller åka rullstol) mer</div>
						<v-radio-group class="mt-0" v-model="more.walking" row>
									<v-radio label="Ja" value="Ja"></v-radio>
									<v-radio label="Planerar att göra det" value="Planerar att göra det"></v-radio>
									<v-radio label="Nej" value="Nej"></v-radio>
							</v-radio-group>
						</div>

						<div class="survey-radio-row">
							<div class="survey-radio-row-first" :class="{surveyError: errors.includes('moreBiking')}">...cykla mer</div>
						<v-radio-group v-model="more.biking" row>
									<v-radio label="Ja" value="Ja"></v-radio>
									<v-radio label="Planerar att göra det" value="Planerar att göra det"></v-radio>
									<v-radio label="Nej" value="Nej"></v-radio>
							</v-radio-group>
						</div>

						<div class="survey-radio-row">
							<div class="survey-radio-row-first" :class="{surveyError: errors.includes('moreTransit')}">...åka mer kollektivtrafik (av någon typ)</div>
						<v-radio-group v-model="more.transit" row>
									<v-radio label="Ja" value="Ja"></v-radio>
									<v-radio label="Planerar att göra det" value="Planerar att göra det"></v-radio>
									<v-radio label="Nej" value="Nej"></v-radio>
							</v-radio-group>
						</div>

						<div class="survey-radio-row">
						<div class="survey-radio-row-first" :class="{surveyError: errors.includes('moreCar')}">...åka bil på ett mer hållbart sätt, t.ex. elbil, samåkning, bilpool, etc.</div>
						<v-radio-group v-model="more.car" row>
									<v-radio label="Ja" value="Ja"></v-radio>
									<v-radio label="Planerar att göra det" value="Planerar att göra det"></v-radio>
									<v-radio label="Nej" value="Nej"></v-radio>
							</v-radio-group>
						</div>

					<h4 class="mb-3 mt-10">Kommentar <span style="font-weight:normal;">(ej obligatorisk)</span></h4>
					<v-textarea rows="4" hide-details solo v-model="commentary"></v-textarea>
					<div class="survey-help mt-2">(Vänligen lämna inga personuppgifter i detta fält)</div>

					<h4 class="mb-3 mt-6" :class="{surveyError: errors.includes('resvanaRecommend')}">Hur troligt är det att du skulle rekommendera Resvana till en kollega eller vän?</h4>
					<vue-slider marks class="pb-10" :max="10" v-model="resvanaRecommend"></vue-slider>
				</div>
				<div class="nudgd-btn inline survey-submit mt-10" @click="submitResponse()">
					Skicka svar
				</div>
				<div class="nudgd-btn small survey-submit mt-10" @click="prevStep()">Tillbaka</div>
			</div>

			<v-progress-linear color="#00A19A" height="10" rounded class="mt-8" :value="(stepIndex + 1) / steps.length * 100"></v-progress-linear>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import lgr from 'largest-remainder-round'

export default {
	name: 'Vue',
	components: {VueSlider},

	mounted() {
		this.uuid = Math.random().toString(36).substr(2, 5)
		this.$store.state.surveyId = 9

		// For testing purposes
		if (this.$route.query.page) {
			this.stepIndex = parseInt(this.$route.query.page)
		}
	},

	data() {
		return {
			modeOfTransportFrequency: ['0 dag/v', '1 dag/v', '2 dagar/v', '3 dagar/v', '4 dagar/v', '5 dagar/v', '6 dagar/v', '7 dagar/v'],
			steps: [0, 1],
			stepIndex: 0,
			uuid: null,
			firstStepConfirmed: false,

			numberOfTrips: 10,
			averageTripDistance: 10,
			weeklyDistanceRatio: [0, 20, 40, 60, 80, 100],
			fuelRatio: [0, 33, 66, 100],

			frequencyCar: null,
			frequencyBike: null,
			frequencyMisc: null,
			frequencyWalk: null,
			frequencyTransit: null,
			answeredPreSurvey: null,

			weeklyDistanceRatioProcess: dotsPos => [
	          [dotsPos[0], dotsPos[1], { backgroundColor: '#2FA131' }],
	          [dotsPos[1], dotsPos[2], { backgroundColor: '#1BAACC' }],
	          [dotsPos[2], dotsPos[3], { backgroundColor: '#FD682F' }],
	          [dotsPos[3], dotsPos[4], { backgroundColor: '#243CAC' }],
	          [dotsPos[4], dotsPos[5], { backgroundColor: '#CE349D' }],
	        ],

	        fuelRatioProcess: dotsPos => [
	          [dotsPos[0], dotsPos[1], { backgroundColor: '#2FA131' }],
	          [dotsPos[1], dotsPos[2], { backgroundColor: '#1BAACC' }],
	          [dotsPos[2], dotsPos[3], { backgroundColor: '#000' }],
	        ],

					resvanaEffect: null,
					resvanaRecommend: null,
					more: {
						walking: null,
						biking: null,
						transit: null,
						car: null
					},
					commentary: null,
	        engaged: [],
	        usedResvana: null,

	        // Each array represents the required fields of a step
	        required: [
	        	['numberOfTrips', 'averageTripDistance', 'frequencyCar', 'frequencyBike', 'frequencyWalk', 'frequencyMisc', 'frequencyTransit'],
	        	['answeredPreSurvey'],
	        ],

	        errors: []
		}
	},

	watch: {
		frequencyCar(val) { this.engaged.push('frequencyCar') },
		frequencyBike(val) { this.engaged.push('frequencyBike') },
		frequencyWalk(val) { this.engaged.push('frequencyWalk') },
		frequencyTransit(val) { this.engaged.push('frequencyTransit') },
		frequencyMisc(val) { this.engaged.push('frequencyMisc') },

		numberOfTrips(val) { this.engaged.push('numberOfTrips') },
		averageTripDistance(val) { this.engaged.push('averageTripDistance') },
		weeklyDistanceRatio(val) { this.engaged.push('weeklyDistanceRatio') },
		fuelRatio(val) { this.engaged.push('fuelRatio') },
		answeredPreSurvey(val) { this.engaged.push('answeredPreSurvey') },
	},

	methods: {
		nextStep() {
			if ( ! this.validate()) {
				alert('Var god och fyll i alla rödmarkerade fält')
				return
			}

			window.scrollTo(0, 0)
			this.stepIndex++
			this.saveState()
		},

		resetWeeklyDistanceRatio() {
			this.weeklyDistanceRatio = [0, 20, 40, 60, 80, 100]
		},

		validate() {
			let required = this.required[this.stepIndex]

			// Remove fuelRatio and previousFuelRatio if there's no car involved
			if ( ! this.weeklyCarDistance) { required = required.filter(val => val !== 'fuelRatio') }

			// Remove most items if the person didn't use the service
			if (this.usedResvana !== 'Jag har besökt tjänsten Resvana' && this.usedResvana !== 'Jag har läst minst ett utskick och besökt tjänsten Resvana') {
				required = []
			}

			this.errors = required.filter(val => ! this.engaged.includes(val))

			console.log(this.errors)

			return this.errors.length === 0
		},

		confirmFirstStep() {
			this.firstStepConfirmed = true
		},

		prevStep() {
			window.scrollTo(0, 0)
			this.stepIndex--
		},

		saveState() {
			axios.post(this.$apiUrl + '/api/survey/9', {
				uuid: this.uuid,
				slug: this.$route.params.slug,
				seconds_passed: performance ? parseInt(performance.now() / 1000) : null,
				...this.$data,
				completed_pages: this.stepIndex
			})
		},

		submitResponse() {
			if ( ! this.validate()) {
				alert('Var god och fyll i alla rödmarkerade fält')
				return
			}

			axios.post(this.$apiUrl + '/api/survey/9', {
				uuid: this.uuid,
				slug: this.$route.params.slug,
				seconds_passed: performance ? parseInt(performance.now() / 1000) : null,
				...this.$data,
				completed_pages: this.stepIndex,
				complete: true
			}).then(res => {
				this.$router.push({name: 'SurveyThanks', params: {slug: this.slug}})
            })
		}
	},

	computed: {
		weeklyCarDistance() {
			return Math.round((this.weeklyDistanceRatio[4] - this.weeklyDistanceRatio[3]) / 100 * this.weeklyDistance)
		},

		weeklyDistance() {
			return (this.averageTripDistance * this.numberOfTrips).toFixed(0).replace('.', ',')
		},

		yearlyDistance() {
			return (this.averageTripDistance * this.numberOfTrips) * 52
		},

		slug() {
			// Cookie slug precedence
			if (this.$getCookie('openEndUser')) {
				return this.$getCookie('openEndUser')
			}

			return this.$route.params.slug
		}
	}
}
</script>
